import { gql } from '@apollo/client'

export const COMPANY_STORE_DISTRIBUTIONS = gql`
  query CompanyStoreDistributions($companyStoreId: ID!) {
    distributions(companyStoreId: $companyStoreId) {
      storeDistributedUpcs
    }
  }
`
